"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const classnames = require("classnames");
class Dropdown extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.container = null;
        this.classNamesBySize = {
            xsm: 'xsm',
            sm: 'sm vf-btn--sm',
            md: null
        };
        this.handleClickOutside = (ev) => {
            if (!!this.container && !this.container.contains(ev.target)) {
                this.container.classList.remove('active');
            }
        };
        this.toggleDropdown = (evt) => {
            if (evt) {
                evt.stopPropagation();
                evt.preventDefault();
            }
            if (this.props.disabled)
                return;
            this.container.classList.toggle('active');
        };
        this.getDefaultComponent = () => {
            const { title } = this.props;
            return (React.createElement("button", { className: this.getButtonClassNames(), onClick: this.toggleDropdown }, title));
        };
        this.getButtonClassNames = () => {
            const { size, showDropdownExpandedIndicator, disabled } = this.props;
            return classnames('vf-btn', 'vf-btn-flat', `vf-btn--${size}`, {
                'with-indicator': showDropdownExpandedIndicator,
                'disabled': disabled
            });
        };
        this.getSelectClassNames = () => {
            const { position, className } = this.props;
            return classnames('vf-select', `vf-dropdown-${position}`, 'has-dropdown', className);
        };
        this.getDropdownClassNames = () => {
            const { menuClassName, size } = this.props;
            return classnames('vf-dropdown-menu', menuClassName, this.classNamesBySize[size]);
        };
    }
    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
    render() {
        const { children, component = this.getDefaultComponent() } = this.props;
        return (React.createElement("div", { ref: r => this.container = r, className: this.getSelectClassNames() },
            React.createElement("div", { className: 'vf-dropdown cursor-pointer', onClick: this.toggleDropdown }, component),
            React.createElement("div", { className: this.getDropdownClassNames() }, children)));
    }
}
Dropdown.defaultProps = {
    position: 'bottom',
    size: 'sm',
    showDropdownExpandedIndicator: true,
    disabled: false
};
exports.default = Dropdown;
